import * as requestFromServer from '../common/cruds'
import { NotificationSlices } from './slices'
import { callTypes, catchError } from '../common/slices'

const actions = NotificationSlices.actions

export const getNotificationList = () => (dispatch: any) => {
    return requestFromServer
        .getRequest(`${process.env.REACT_APP_API_BASE_URL}notifications?page=1&items_per_page=10`)
        .then(response => {
            dispatch(actions.notificationList(response.data.data))
        })
        .catch(error => {
            error.clientMessage = 'Can\'t find a list of notifications'
            dispatch(catchError({ error, callType: callTypes.action }))
        })
}